import {jwtDecode} from 'jwt-decode'

export function getSessionJwt() {
  const token = localStorage.getItem("token");
  return jwtDecode(token);
}
